// Operator dashboard auth — single-operator MVP. Bearer token stored in
// localStorage. The token (DASHBOARD_SECRET) is set on the Worker and
// pasted into the dashboard once on first visit.
//
// When we onboard a teammate or a lessee portal we'll swap for proper
// OAuth / Cloudflare Access. This is intentionally minimal until then.

const STORAGE_KEY = "rankforge.dashboard.token";

/**
 * Strip whitespace + non-printable chars. Pasted tokens often pick up a
 * trailing newline from copy-paste; the Headers constructor rejects them
 * with `TypeError: The string did not match the expected pattern.` —
 * which surfaces as a confusing "Failed: ..." in every dashboard query
 * until the operator manually clears the token. Sanitize on read + write
 * so this can't recur.
 */
function sanitize(s: string): string {
  return s.replace(/[^\x20-\x7E]/g, "").trim();
}

export function getToken(): string | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? sanitize(raw) : null;
}

export function setToken(token: string): void {
  localStorage.setItem(STORAGE_KEY, sanitize(token));
}

export function clearToken(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function authHeaders(): HeadersInit {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
